import { ResponseUserMascotInner } from "../queries/useGetUserMascots";
import { ResponseLoyaltyMascotInner } from "../queries/useGetLoyaltyMascots";
import { ILoyaltyAvatarListItem } from "../types/Loyalty";

export const formatMascotsToListAvatars = (
  userMascots?: ResponseUserMascotInner[],
  loyaltyMascots?: ResponseLoyaltyMascotInner[],
): ILoyaltyAvatarListItem[] => {
  if (!loyaltyMascots) {
    return [];
  }

  if (!userMascots && loyaltyMascots) {
    return loyaltyMascots.map((mascot) => ({
      id: mascot.id,
      avatar: mascot.link,
      locked: true,
    }));
  }

  const linksUsersMascots = userMascots?.map((mascot) => mascot.link);

  return loyaltyMascots
    .map((mascot) => ({
      id: mascot.id,
      avatar: mascot.link,
      locked: !linksUsersMascots?.includes(mascot.link),
    }))
    .sort((a) => (a.locked ? 1 : -1));
};
